import axios from "axios";
//
import { HOST } from "./apiClient";

const axiosInstance = axios.create({
    baseURL: HOST + "/api",
});

export { axiosInstance as axios };
